import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { CatalogService } from '@catalog/catalog.service';
import { MatSelectChange } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
import { BANNER_SECTIONS, 
         MAX_FILE_SIZE,
         Maximum_image_upload_file_size_2mb,
         format_not_allowed,
         Please_upload_Image,
         LOGIN_COUNT_SOURCE} from '@root/app.constant';
import { FileInputComponent } from '@common/file-input/file-input';
import { NgForm } from '@angular/forms';
import { ErrorHandler } from '@root/utils/error-handler.service';
@Component({
  selector: 'app-catalogue-images',
  templateUrl: './catalogue-images.component.html',
  styleUrls: ['./catalogue-images.component.scss'],
  providers: [CatalogService],
})
export class CatalogueImagesComponent implements OnInit {
  @ViewChild('f', { static: false }) form: NgForm;

  @ViewChild(FileInputComponent, { static: false })
  fileInputComponent: FileInputComponent;

  //sectionList = BANNER_SECTIONS;

  @Input() sectionList : any;

  selectedSelection: string;

  schemeList = [];

  selecteScheme: string;

  selectedSource : string;

  fundManagerList = [];

  selectedFundManger: string;

  featureList = [];

  selectedFeature: string;

  selectedInvestmentApproach: string;

  fileName: string;

  file: File;

  bannerList = [];

  keyFeatureList = [];

  investmentApproachList = [];

  urlSelection : any;

  sourceList = LOGIN_COUNT_SOURCE;

  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandler
  ) {}

  ngOnInit() {
    this.readAllSchems();
    this.readBanners();
  }

  private readAllSchems() {
    this.catalogService.readAllSchemes().subscribe(
      (response) => {
        this.schemeList = response.data.schemes;
      },
      (error) => {}
    );
  }

  private readAllFundManagers() {
    this.catalogService.readAllFundmangers().subscribe(
      (response) => {
        this.fundManagerList = response.data.list;
      },
      (error) => {}
    );
  }

  private readAllKeyFeatures() {
    this.catalogService.readAllKeyFeature().subscribe(
      (respose) => {
        this.keyFeatureList = respose.data.list;
      },
      (error) => {}
    );
  }

  private readAllInvestmentApproches(){
    this.catalogService.readAllInvestmentApproach().subscribe(
      response => {
        this.investmentApproachList = response.data.list
      },
      error => {}
    )
  }

  public onFileChange(file: File) {
    this.file = file;
    if (this.file) {
      let isValid =  true;
      const fsize = this.file.size;
      if (fsize > MAX_FILE_SIZE) {
        this.toastr.error(Maximum_image_upload_file_size_2mb);
        isValid = false;
      } else  if (this.file.type !== 'image/jpeg' && this.file.type !== 'image/png') {
        this.toastr.error(format_not_allowed);
        isValid = false;
      }

      if(!isValid){
        this.clearFileComponent();
      }
    } else {
      this.fileName = null;
    }
  }

  private clearFileComponent(){
    if( this.fileInputComponent){
      this.fileInputComponent.clear();
      this.file = null;
      setTimeout(() => {
        this.fileName = null;
      });
    }
  }

  private uploadBanner() {
    const formData: any = new FormData();
    formData.append('file', this.file);
    formData.append(
      'schemeCode',
      this.selecteScheme ? this.selecteScheme : null
    );
    formData.append(
      'clickableUrl',
      this.urlSelection ? this.urlSelection : null
    );
    formData.append('startDate', null);
    formData.append('endDate', null);
    if(this.selectedSource){
      if(this.selectedSource === 'W'){
        formData.append('isWebBanner', true);
      }else{
        formData.append('isWebBanner', false)
      }
    }else{
      formData.append('isWebBanner', "");
    }
    formData.append('bannerType', this.selectedSelection);

    this.catalogService.uploadBanner(formData).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.readBanners();
          this.resetForm(this.selectedSelection);
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  private uploadFundMangerImage() {
    const formData: any = new FormData();
    formData.append('file', this.file);
    formData.append('fundManagerName', this.selectedFundManger);
    this.catalogService.uploadFundManagerBanner(formData).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.resetForm(BANNER_SECTIONS[1].value);
          this.readAllKeyFeatures();
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  private uploadKeyFeatureImage() {
    const formData: any = new FormData();
    formData.append('file', this.file);
    formData.append('keyHeading', this.selectedFeature);
    
    this.catalogService.uploadKeyFeatureImage(formData).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.resetForm(BANNER_SECTIONS[2].value);
          this.readAllFundManagers();
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  private uploadInvestmentApproachImage() {
    const formData: any = new FormData();
    formData.append('file', this.file);
    formData.append('investorApproachHeading', this.selectedFeature);
    this.catalogService.uploadInvestmentApproachImage(formData).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
          this.resetForm(BANNER_SECTIONS[2].value);
          this.readAllFundManagers();
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  private readBanners() {
    const data = { source: this.selectedSource ? this.selectedSource : '', bannerType: this.selectedSelection };
    this.catalogService.readAllBanner(data).subscribe(
      (response) => {
        if(response.status === 0){
          this.bannerList = [...response.data.banners];
          
        }else{
          this.bannerList = [];
        }
        
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  private resetForm(section?: string) {
    this.file = null;
    this.fileName = null;
    this.selecteScheme = null;
    this.selectedFundManger = null;
    this.selectedFeature = null;
    this.form.resetForm();
    setTimeout(() => {
      this.selectedSelection = section ? section : BANNER_SECTIONS[0].value;
    });
  }

  proceesData = () => {
    if (!this.file) {
      this.toastr.error(Please_upload_Image);
      return;
    }
    switch (this.selectedSelection) {
      case 'Banners for Product':
      case 'Banners for NFO':
      case 'Banners for CEO':
      case 'Banners for Careers':
      case 'Banners for LTEF':
      case 'Banners for Investor NFO':
        this.uploadBanner();
        break;
      case 'Fund managers':
        this.uploadFundMangerImage();
        break;
      case 'Key features':
        this.uploadKeyFeatureImage();
        break;
        case 'Investment Approach':
          this.uploadInvestmentApproachImage();
          break;  
    }
  };

  public onSelectionChange(change: MatSelectChange) {
    switch (change.value) {
      case 'Banners for Product':
      case 'Banners for NFO':
      case 'Banners for CEO':
      case 'Banners for Careers':
      case 'Banners for LTEF':
      case 'Banners for Investor NFO':
        this.readAllSchems();
        this.readBanners();
        break;
      case 'Fund managers':
        this.readAllFundManagers();
        break;
      case 'Key features':
        this.readAllKeyFeatures();
        break;
      case 'Investment Approach':
        this.readAllInvestmentApproches();  
    }
  }

  public onSourceChange(change: MatSelectChange){
    if(change.value){
      this.readBanners()
    }
  }
}
